module.exports = __webpack_public_path__ + "img/c08_unitgathererelephant_Normal_ua.aba5ce20.webp";